<script lang="ts">
  import SellSheetsPreview from "@distributor/svelte/SellSheet/Preview.svelte";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import { params } from "@roxi/routify";
  import Spinner from "@shared/svelte/Components/SpinnerInternal.svelte";

  const load = async () => {
    let sellSheet = await HttpPromise({
      method: "GET",
      url: "/api/distributor/sell_sheets/" + $params.productSheetId,
      data: $params,
    });
    return sellSheet;
  };

</script>

{#await load()}
  <Spinner />
{:then sellSheet}
  <SellSheetsPreview {sellSheet} pdf={$params.pdf} />
{/await}
